import { h as __h } from "preact";
/** @import { ComponentChildren } from "preact"; */

import html from "~/util/html.js";
import Title from "~/util/title.js";
import Icon from "~/component/Icon.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./PublicLayout.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./PublicLayout.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {string} title
 * @property {(ev: SubmitEvent & { currentTarget: HTMLFormElement }) => unknown} [onSubmit] Wraps
 *   the children in a `<form>` instead of a `<div>`
 * @property {string} [class]
 * @property {ComponentChildren} [children]
 */

/** @param {Props} props */
export default function PublicLayout({
  title,
  onSubmit,
  class: className,
  children
}) {
  const Body = onSubmit ? "form" : "div";
  return [__h(Title, {
    title: title
  }), __h("div", {
    "class": css.page
  }, __h("div", {
    "class": css.content
  }, __h(Icon, {
    name: "phaze",
    size: 48
  }), __h("main", {
    "class": css.main
  }, __h("h1", {
    "class": css.title
  }, title), __h(Body, {
    "class": className ? `${css.body} ${className}` : css.body,
    onSubmit: onSubmit
  }, children))))];
}

/** @param {{ children?: ComponentChildren }} props */
export function FooterPrompt({
  children
}) {
  return __h("p", {
    "class": css.footerPrompt
  }, children);
}